import React from "react";
import { Helmet } from "react-helmet";

const BASE_URL = "https://www.americanlegacytours.com";
const DEFAULT_IMAGE =
  "https://res.cloudinary.com/american-legacy-tours/image/upload/c_fill,h_630,w_1200/f_auto,q_auto/img/home/slider/slider-01";

const PageSEO = ({ title, description, image, path, type = "website", schema }) => {
  const canonical = `${BASE_URL}${path || ""}`;
  const ogImage = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="American Legacy Tours" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {schema && Array.isArray(schema)
        ? schema.map((s, i) => (
            <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
          ))
        : schema && (
            <script type="application/ld+json">{JSON.stringify(schema)}</script>
          )}
    </Helmet>
  );
};

export default PageSEO;
